import { render } from "./NewShopDetails.vue?vue&type=template&id=ba8f041c&scoped=true"
import script from "./NewShopDetails.vue?vue&type=script&lang=js"
export * from "./NewShopDetails.vue?vue&type=script&lang=js"

import "./NewShopDetails.vue?vue&type=style&index=0&id=ba8f041c&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8f041c"]])

export default __exports__